import axios from "axios";
import { Dispatch, SetStateAction } from "react";
import { AnyIfEmpty } from "react-redux";
import { GET_PROPERTY_EVENTS_FAILURE, GET_PROPERTY_EVENTS_REQUEST, GET_PROPERTY_EVENTS_SUCCESS } from "../constants/key-pickup-drop-events.constants";

interface PropertyEventObj {
    locationId: string;
    name: string;
    email: string;
    phone: string;
    eventName: string;
    description: string;
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
    locker: number;
}

const getPropertyEventsRequest = () => {
    return {
        type: GET_PROPERTY_EVENTS_REQUEST,
    };
};

const getPropertyEventsSuccess = (propertyEventData: AnyIfEmpty<object>) => {
    return {
        type: GET_PROPERTY_EVENTS_SUCCESS,
        payload: propertyEventData,
    };
};

const getPropertyEventsFailure = (propertyEventError: string) => {
    return {
        type: GET_PROPERTY_EVENTS_FAILURE,
        payload: propertyEventError,
    };
};
export const createPropertyEvent = (
    eventObj: PropertyEventObj,
    setLoading: Dispatch<SetStateAction<boolean>>,
    onSuccess?: (message: string, eventData?: any) => void,
    onFailure?: (message: string, type?: string) => void
) => {
    return () => {
        setLoading(true);
        return axios
            .post("/property-events", eventObj, {
                headers: { 'x-internal-api': 'true' },
            })
            .then((response) => {
                const status = response?.data?.statusCode;
                const message = response?.data?.message;
                const type = response?.data?.type?.toString()?.toLowerCase();
                const eventData = response?.data?.data; // Get the created event data

                if (status === 201 || status === 200) {
                    onSuccess && onSuccess(message || "Event created successfully", eventData);
                } else {
                    onFailure && onFailure(message || "Something went wrong", type);
                }
            })
            .catch((error) => {
                const message = error?.response?.data?.message || "Something went wrong";
                onFailure && onFailure(message);
            })
            .finally(() => {
                setLoading(false);
            });
    };
};


export const getPropertyEvents = ({
    search,
    page,
    limit,
    setTotalCount,
    locationId,
}: {
    search?: string;
    page?: number;
    limit: number;
    setTotalCount: Dispatch<SetStateAction<number>>;
    locationId?: string;
}) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getPropertyEventsRequest());
        return axios
            .get(`/property-events/get-all-events`, {
                params: {
                    searchText: search,
                    page: page,
                    limit: limit,
                    ...(locationId ? { location: locationId } : {}),
                },
                headers: {
                    'x-internal-api': 'true',
                },
            })
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    setTotalCount(response?.data?.count ?? 0)
                    // Support multiple API response shapes: EventData, data, or direct array
                    const eventList = response.data?.EventData ?? response.data?.data ?? (Array.isArray(response.data) ? response.data : []);
                    dispatch(getPropertyEventsSuccess(eventList))
                } else {
                    setTotalCount(0)
                    dispatch(getPropertyEventsFailure(response.data.message))
                }
            }).catch((error) => {
                setTotalCount(0);
                dispatch(getPropertyEventsFailure(error?.response?.data?.message || 'Something went wrong'));
            });
    }
}

export const deletePropertyEvents = (id: string, onSuccess?: (message: string) => void, onFailure?: (message: string) => void) => {
    return () => {
        axios.delete(`/property-events/property-event/${id}`, {
            headers: { 'x-internal-api': 'true' },
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    onSuccess && onSuccess(response?.data?.message)
                } else {
                    onFailure && onFailure(response?.data?.message)
                }
            }).catch((error) => onFailure && onFailure(error?.response?.data?.message));
    };
};

export const updatePropertyEvent = (
    id: string,
    eventObj: PropertyEventObj,
    setLoading: Dispatch<SetStateAction<boolean>>,
    onSuccess?: (message: string) => void,
    onFailure?: (message: string, type?: string) => void
) => {
    return () => {
        setLoading(true);
        return axios
            .put(`/property-events/${id}`, eventObj, {
                headers: { 'x-internal-api': 'true' },
            })
            .then((response) => {
                const status = response?.data?.statusCode;
                const message = response?.data?.message;
                const type = response?.data?.type?.toString()?.toLowerCase();

                if (status === 200) {
                    onSuccess && onSuccess(message || "Event updated successfully");
                } else {
                    onFailure && onFailure(message || "Something went wrong", type);
                }
            })
            .catch((error) => {
                const message = error?.response?.data?.message || "Something went wrong";
                onFailure && onFailure(message);
            })
            .finally(() => {
                setLoading(false);
            });
    };
};
